import React from 'react';
import { FieldValues, Path } from 'react-hook-form';
import { translate } from '../../services/translate';
import RadioList from './RadioList';

function RadioYesNo<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    return <RadioList
        name={name}
        clearValue={null}
        items={[
            { label: translate('yes'), value: 'yes' },
            { label: translate('no'), value: 'no' },
        ]}
    />;
}

RadioYesNo.getCount = RadioList.getCount;

export default RadioYesNo;
